import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CreditCardIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 22"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15 9.71256V15.7215C15 16.8277 14.3284 17.7245 13.5 17.7245H2.5C1.67157 17.7245 1 16.8277 1 15.7215V9.71256H15ZM12.5 11.0479H9.5C9.22386 11.0479 9 11.3468 9 11.7156V13.0509C9 13.4196 9.22386 13.7185 9.5 13.7185H12.5C12.7761 13.7185 13 13.4196 13 13.0509V11.7156C13 11.3468 12.7761 11.0479 12.5 11.0479ZM13.5 4.37125C14.3284 4.37125 15 5.26801 15 6.37424V7.0419H1V6.37424C1 5.26801 1.67157 4.37125 2.5 4.37125H13.5Z"
		/>
	</svg>
))
